import {
  confirmPasswordSchema,
  passwordSchema,
  stringSchema,
} from "components/inputs/validationSchema";
import { TFunction } from "i18next";
import * as yup from "yup";

export const fieldNames = {
  name: "name",
  email: "email",
  message: "message",
  serviceType: "serviceType",
  phone: "phone",
} as const;

export const validation = (URL_ID: string | undefined, t: TFunction) => {
  return yup.object().shape({
    [fieldNames.email]: stringSchema(fieldNames.email, t),
    [fieldNames.phone]: stringSchema(fieldNames.phone, t),
    [fieldNames.name]: stringSchema(fieldNames.name, t),
    [fieldNames.message]: stringSchema(fieldNames.message, t),
    [fieldNames.serviceType]: stringSchema(fieldNames.serviceType, t),
  });
};
